import { render, staticRenderFns } from "./ImsDescription.vue?vue&type=template&id=f3fb1170&scoped=true"
import script from "./ImsDescription.vue?vue&type=script&lang=js"
export * from "./ImsDescription.vue?vue&type=script&lang=js"
import style0 from "./ImsDescription.vue?vue&type=style&index=0&id=f3fb1170&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3fb1170",
  null
  
)

export default component.exports